import { Controller } from "@hotwired/stimulus"

// Lo stato dei componenti React che sopravviveva a un nuovo carica() di pages/Piani.js: prima di ogni Turbo Stream si
// annota lo stato degli elementi con `data-conserva="<chiave>"` dentro questo elemento e dopo lo si rimette su quelli
// nuovi con la stessa chiave. Campi: il valore (se l'opzione c'è ancora); <details>: aperto; altri (form, pulsanti):
// hidden e disabled. Dentro un elemento `data-conserva-azzera="si"` (form svuotato dopo la conferma) non si rimette niente.
export default class extends Controller {
  connect() {
    this.prima = (event) => {
      const render = event.detail.render
      event.detail.render = async (stream) => {
        const stato = this.annota()
        await render(stream)
        this.rimetti(stato)
      }
    }
    document.addEventListener("turbo:before-stream-render", this.prima)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.prima)
  }

  annota() {
    const stato = new Map()
    this.element.querySelectorAll("[data-conserva]").forEach((el) => {
      stato.set(el.dataset.conserva, { valore: el.value, open: el.open, hidden: el.hidden, disabled: el.disabled })
    })
    return stato
  }

  rimetti(stato) {
    this.element.querySelectorAll("[data-conserva]").forEach((el) => {
      const s = stato.get(el.dataset.conserva)
      if (!s || el.closest("[data-conserva-azzera='si']")) return
      if (el.tagName === "SELECT") {
        if ([...el.options].some((o) => o.value === s.valore)) el.value = s.valore
      } else if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
        el.value = s.valore
      } else if (el.tagName === "DETAILS") {
        el.open = s.open
      } else {
        el.hidden = s.hidden
        el.disabled = s.disabled
      }
    })
  }
}
